import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { createThemeData, emptyCSSTemplateFunc } from '@hzero-front-ui/core';
import { EUedThemeName } from '@hzero-front-ui/core/lib/utils/constants';
import { css } from 'styled-components';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import cloneDeep from 'lodash/cloneDeep';
var cfgPk = require('@hzero-front-ui/cfg/package.json');

/**
 *
 * @param group
 * 需要获取 keys 的集合
 * @param field
 * 需要获取 key 的对应键名
 * @returns
 * 返回 keys
 */
var getKeys = function getKeys(group, field) {
  if (field) {
    if (isArray(group)) {
      var keys = group.map(function (oo) {
        return oo[field];
      });
      return keys;
    } else if (isObject(group)) {
      var _keys = [];
      for (var key in group) {
        _keys.push(group[key][field]);
      }
      return _keys;
    }
  } else {
    if (isObject(group)) {
      return Object.keys(group);
    }
    return [];
  }
};
/**
 *
 * @param originalVar
 * 单个组件初始数据和模板变量
 * @param newVar
 * 单个组件新数据和模板变量
 * @param templateType
 * @returns
 * 融合后的新模板 {base: xxx, pro: xxx, hzero: xxx}
 */

var fusionTemplate = function fusionTemplate(originalVar, newVar, templateType) {
  var templateKeys = getKeys(_objectSpread(_objectSpread({}, originalVar[templateType]), newVar[templateType]));
  var newTemplate = {};
  templateKeys.forEach(function (t) {
    var preTempltate = originalVar[templateType][t] || emptyCSSTemplateFunc;
    var nextTemplate = newVar[templateType][t] || emptyCSSTemplateFunc;
    newTemplate[t] = preTempltate === emptyCSSTemplateFunc && nextTemplate === emptyCSSTemplateFunc ? emptyCSSTemplateFunc : css(["", " ", ""], preTempltate, nextTemplate);
  });
  return newTemplate;
};
/**
 *
 * @param originalVars
 * 原始主题数据
 * @param newVars
 * 需要覆盖的组件数据
 * @returns
 * ThemeData
 */

export var toModifyVars = function toModifyVars(originalVars, newVars) {
  var pureOriginalVars = cloneDeep(originalVars);
  var newVarsKeys = getKeys(newVars, 'name');
  var finalVars = pureOriginalVars.map(function (comp) {
    if (newVarsKeys.includes(comp.name)) {
      var index = newVars.findIndex(function (_ref) {
        var name = _ref.name;
        return name === comp.name;
      }); // replaceData 用于判定是否是使用 theme5 模板的基础上进行变量覆盖操作

      comp.data[0] = newVars[index].replaceData ? newVars[index].data[0] : Object.assign(comp.data[0], newVars[index].data[0]); // 模板处理: 将 theme2 中的模板和 theme5 融合

      if (newVars[index].fusionTemplate) {
        // 融合 onlyTemplate
        if (newVars[index].onlyTemplate) comp.onlyTemplate = fusionTemplate(comp, newVars[index], 'onlyTemplate'); // 融合 extraTemplate

        if (newVars[index].extraTemplate) comp.extraTemplate = fusionTemplate(comp, newVars[index], 'extraTemplate');
      } else {
        // 模板处理： 追加或者替换 (pro/base/hzero)
        if (newVars[index].onlyTemplate) comp.onlyTemplate = Object.assign(comp.onlyTemplate || {}, newVars[index].onlyTemplate);
        if (newVars[index].extraTemplate) comp.extraTemplate = Object.assign(comp.extraTemplate || {}, newVars[index].extraTemplate);
      }
    }
    return comp;
  });
  var cfgIsGreaterThan40x = function cfgIsGreaterThan40x() {
    if (cfgPk && cfgPk.version) {
      var versionArr = cfgPk.version.split('.');
      if (parseInt(versionArr[0]) > 4 || parseInt(versionArr[0]) === 4 && parseInt(versionArr[1]) > 0) {
        return true;
      }
    }
    return false;
  };
  return createThemeData(finalVars, {
    __uedThemeName__: EUedThemeName.theme2,
    // cfg 版本大于 4.0.x 时，UED 中启用 主题2
    __isEmpty__: !cfgIsGreaterThan40x()
  });
};